module.exports = __webpack_public_path__ + "static/img/bfyy.13e9ab3.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/bfyy.png
// module id = FzSc
// module chunks = 0